import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { forgotPasswordAction } from '../../_actions';
import '../Login/login.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../images/OPPTIMISE_logo.png';


import { userProfileConstants } from '../../_constants';

import { LoaderComp } from '../../_components/common/LoaderComp/Loadercomp';


import './index.css';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);



        this.state = {
            email: '',
            submitted: false

        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: userProfileConstants.REQUEST_FORGOT_PASSWORD
        })
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });

        const data = {
            email: this.state.email,
        }

        this.props.dispatch(forgotPasswordAction.forgotPasswordHandler(data));
    }

    render() {

        const { email, submitted } = this.state;
        return (
            <div className="login-page text-white">
                <div className="logo text-center text-md-left py-3 px-md-5">
                    <img src={logo} alt="OPPTiMiSE" />


                </div>

                <div className="container pt-5">
                    <div className="d-flex flex-row justify-content-center">
                        <div className="col-lg-5 col-md-8 col-11 px-0">
                            <div className="login-field-page">
                                <p className="h5 text-center py-3 py-lg-2">Forgot Password</p>
                                {
                                    this.props.state.forgotPasswordReducer.status === false &&
                                    <React.Fragment>
                                        <p style={{ fontSize: '14px' }} className="text-center col-12">The password reset instructions will be sent to the email ID if the account exists.</p>
                                        {
                                            this.props.forgotPasswordResponse !== '' &&
                                            <div className="error-message-forgot-password">
                                                <i className="fa fa-exclamation-triangle" style={{ marginRight: 10, color: 'rgb(238, 201, 9)' }}></i>
                                                <p>{this.props.forgotPasswordResponse}</p>
                                            </div>
                                        }
                                        <div className="">
                                            <form
                                                method="post"
                                                onSubmit={
                                                    this.handleSubmit
                                                }
                                            >
                                                <div className="form-group">
                                                    <label htmlFor="email" className="text-uppercase"><small>EMAIL ID</small></label>
                                                    <input
                                                        type="email" className="form-control" id="email" placeholder="name@company.com"
                                                        name="email"
                                                        required
                                                        value={email}
                                                        onChange={this.handleChange}
                                                    />
                                                    {submitted && !email &&
                                                        <div className="help-block">Email is required</div>
                                                    }
                                                </div>

                                                <div className="form-group">
                                                    <div className="text-center">
                                                        <button
                                                            type="submit"
                                                            className="btn buttonColor text-white btn-sm"
                                                        >
                                                            <small>SEND INSTRUCTIONS</small>
                                                        </button>
                                                        {
                                                            (this.props.state.forgotPasswordReducer.status === false && this.props.state.forgotPasswordReducer.error === false) && this.state.submitted === true &&
                                                            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0 0 0' }}>
                                                                <LoaderComp />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <p className="text-center "><Link className="text-white" to='/login'> <small>Back to Login</small></Link></p>

                                            </form>
                                        </div>

                                    </React.Fragment>

                                }

                                {
                                    this.props.state.forgotPasswordReducer.status === true &&
                                    <React.Fragment>
                                        <p className="text-center">Please check your mail for instructions </p>
                                        <div className="text-center">
                                            <Link to='/login' className="btn btn-sm text-white buttonColor">BACK TO LOGIN</Link>
                                        </div>
                                    </React.Fragment>
                                }

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        );
    }
}

function mapStateToProps(state) {

    const { forgotPasswordLoading } = state.forgotPasswordReducer;
    const forgotPasswordResponse = (!forgotPasswordLoading) ? state.forgotPasswordReducer.data : '';
    const forgotPasswordResponseCode = (!forgotPasswordLoading) ? state.forgotPasswordReducer.data.status : '';

    return {
        forgotPasswordResponse,
        forgotPasswordResponseCode,
        state
    };
}

const connectedForgotPassword = connect(mapStateToProps)(ForgotPassword);
export { connectedForgotPassword as ForgotPassword }; 


// WEBPACK FOOTER //
// ./src/_pages/ForgotPassword/index.jsx